<template>
  <div class="app-root min-h-screen bg-gray-50 text-body">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onMounted(() => {
  auth.restoreSession()
})
</script>

<style>
.app-root {
  font-family: 'Inter', 'Be Vietnam Pro', 'Noto Sans SC', sans-serif;
}
</style>
